<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';

export default {
  components: {
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
      }),
      require: true,
    },

  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  setup() {
    return {
      // Filter
      avatarText,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <div>
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Canal De Venda"
                label-for="canalvendaid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.canalvendaid"
                    id="canalvendaid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Canal venda"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Grupo Comercial"
                label-for="grupocomercialid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.grupocomercialid"
                    id="grupocomercialid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Grupo Comercial"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Transportadora"
                label-for="transportadoraid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="transportadoraid"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.transportadoraid"
                    id="transportadoraid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Ramo Atividade"
                label-for="clienteramoatividade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Responsavel"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteramoatividade"
                    id="clienteramoatividade"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Ramo Atividade"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Faturamento Parcial"
                label-for="clientefaturamentoparcial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.clientefaturamentoparcial"
                    id="clientefaturamentoparcial"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </validation-observer>

</template>
